import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

 /**
 *  Container get styled from styles.tsx but I don't know what is {children}
 */

const Container = ({ border, children }: ContainerProps) => (
  <StyledContainer border={border}>{children}</StyledContainer>
);

export default Container;
